@let conversation = this.conversation();
@let hasAnyContent = !!form.controls.body.value;

<div class="wrapper pt-1 pb-2">
  <div class="display-flex align-items-flex-end justify-content-center position-relative">
    @if (memberService.account.benefactor) {
      <sb-field-boost
        class="boost-field"
        [class.visually-hidden]="!hasAnyContent"
        [formControl]="form.controls.boosted"
        [wrapped]="true"
      />
    }

    @if (conversation.allow_photos) {
      <div class="actions mr-2@r display-flex align-items-center">
        <button
          #attachPhotoButton
          sbButton
          [hoverShadow]="'blue-glow'"
          [iconOnly]="true"
          [shadow]="'default-sm'"
          [size]="'big'"
          [variant]="'fill-blue-gradient'"
          (click)="onAttachPhotoButtonClick()"
        >
          <sb-icon [name]="'photocamsolid'" [size]="'4'" />
        </button>
      </div>
    }

    <div class="flex-grow-1">
      @if (cachedPrefill === '' && conversation.greeting_prefill) {
        <div
          class="t-10@r color-ash cursor-pointer mb-2"
          [class.visually-hidden]="hideGreeting"
          (click)="clearGreeting()"
        >
          <sb-icon [name]="'simple-remove'" />
          Clear my greeting
        </div>
      }

      <sb-field-message
        [allowVoiceMessage]="conversation.allow_voice_message"
        [autoexpand]="true"
        [autofocus]="(breakpoint2Service.supportsHover$ | async)!"
        [disableValid]="true"
        [formControl]="form.controls.body"
        [hasAnyContent]="hasAnyContent"
        [humanize]="humanize"
        [maxRows]="5"
        [placeholder]="conversation.message_placeholder"
        [rows]="1"
        [sendDisabled]="
          (conversationStore.sendInProgress() && !conversation.allow_instant_messages) ||
          conversationStore.photoUploadInProgress() ||
          !hasAnyContent ||
          !form.valid
        "
        (fieldMouseDown)="onMessageInputMouseDown($event)"
        (record)="onRecord(conversation)"
        (send)="onSend(conversation)"
      />
    </div>
  </div>
</div>

@let standalone = conversationStore.source === 'messages-page' && ('tablet' | breakpointAbove);
<div class="footer" [class.footer--standalone]="standalone">
  <div
    class="footer__content bg-vapor display-flex flex-direction-column justify-content-center"
    [class.border-radius-16]="standalone"
  >
    @if (conversationStore.canRequestOrShareAccess()) {
      <sb-field-checkbox
        [formControl]="form.controls.request_or_share_access"
        [size]="'small'"
        [text]="memberService.account.benefactor ? 'Request Secret Access' : 'Share Secret Access'"
        [variant]="'dimmed'"
      />
    } @else {
      <span class="t-10@r color-iron">
        <span class="t-11@r font-weight-700 color-ash text-transform-uppercase"
          >{{ conversationStore.tip_type() }}:</span
        >
        {{ conversationStore.tip() }}
      </span>
    }
  </div>
</div>
